'use strict';
var Backbone = require('backbone'),
  $ = require('jquery'),
  LazyPicture = Backbone.View.extend({
    initialize: function() {
      this.lazyScroll()
      $(window).on('scroll resize', () => {
        this.lazyScroll()
      })
      if ($(window).scrollTop() > 0) {
        $(window).on('load', () => {
          this.lazyScroll()
        })
      }
    },
    lazyScroll() {
      const $lazy = $('picture.lazy')
      $lazy.each((_index, element) => {
        const elementScroll = $(element).offset().top - window.innerHeight - (window.innerHeight / 3.5)
        const scrollBody = $(window).scrollTop()
        if (elementScroll < scrollBody) {
          $(element).find('source').each((_ind, e) => {
            const datasrc = $(element).find('img').attr('data-original')
            if ($(e).attr('media').match(/\d+/)[0] <= $(window).width()) {
              const dataSrcset = $(e).attr('data-original')
              $(element).find('img').attr('src', datasrc)
              $(e).attr('srcset', dataSrcset)
              $(element).removeClass('lazy')
            } else {
              $(element).find('img').attr('src', datasrc)
              $(element).removeClass('lazy')
            }
          })
        }
      })
    }
  },{
    create: function create() {
      new LazyPicture()
    }
  });

module.exports = LazyPicture;


// WEBPACK FOOTER //
// ./assets/js/LazyPicture.js